// © 2015-2021 WDNA - All Rights Reserved

import api, { AxiosRequestConfig } from '../../../services/api/Connect';

export * from './types';

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function alarm<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('alarm/list', data, options);
    case 'get':
      return id ? api.get(`alarm/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('alarm/set', data, options);
    case 'del':
      return id ? api.get(`alarm/del/${id}`, data, options) : undefined;
    case 'status':
      return api.post('alarm/status', data, options);
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function notice<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('notice/list', data, options);
    case 'get':
      return id ? api.get(`notice/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('notice/set', data, options);
    case 'del':
      return id ? api.get(`notice/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function alarmsAction<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('action/list', data, options);
    case 'get':
      return id ? api.get(`action/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('action/set', data, options);
    case 'del':
      return id ? api.get(`action/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}
